import TournamentInfos from '@features/tournament-details/tournament-infos/tournament-infos';
export default TournamentInfos;
